<script>
  import showImage from 'stores/showImage'
</script>

<button class='btn btn-sm btn-outline-secondary mr-1' type='button'
    class:active={$showImage} on:click={() => { $showImage = !$showImage }}>
  顯示圖片
</button>
